// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ap","headerWrapper":"aq","iconButtonFrame":"ar","iconButton":"as","icon":"at","header":"au","form":"av","buttonWrapper":"aw","button":"ax"};